import { SESSION_KEY } from '@/constants/api';
import { getCookie } from '@/lib/cookie';
import createClient from 'openapi-fetch';
import qs from 'qs';
import { paths } from './types';

// 获取当前语言的函数
const getCurrentLanguage = () => {
  if (typeof window === 'undefined') return 'en';

  // 从 URL 路径中获取语言
  const pathname = window.location.pathname;
  const firstSegment = pathname.split('/').filter(Boolean)[0];

  // 检查第一个路径段是否是支持的语言
  return firstSegment === 'zh' || firstSegment === 'en' ? firstSegment : 'en';
};

const generateUA = () => {
  if (typeof window === 'undefined') {
    return `en|web|0.1.92|0x0|node`;
  }

  // 动态获取语言
  const language = getCurrentLanguage();

  // 获取客户端类型
  const clientType = 'web';

  // 版本号
  const version = '0.1.92';

  // 获取分辨率
  const resolution = `${window.screen.width}x${window.screen.height}`;

  // 获取设备类型
  let deviceType = 'web';

  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
    deviceType = 'ios';
  } else if (userAgent.includes('android')) {
    deviceType = 'android';
  } else if (userAgent.includes('windows')) {
    deviceType = 'windows';
  }

  return `${language}|${clientType}|${version}|${resolution}|${deviceType}`;
};

const sdk = createClient<paths>({
  baseUrl: process.env.NEXT_PUBLIC_CC_API,
  headers: {
    Accept: 'application/json',
  },
  querySerializer(params) {
    return qs.stringify(params, {
      encodeValuesOnly: true,
    });
  },
});

if (typeof window !== 'undefined') {
  sdk.use({
    onRequest: (config) => {
      // const currentUA = generateUA();
      // config.request.headers.set('UA', currentUA);
      if (!config.request.headers.get('Authorization')) {
        config.request.headers.set('Authorization', getCookie(SESSION_KEY) || '');
      }
    },
  });
}

export default sdk;
